import { gql } from "@apollo/client";
export default gql`
  mutation SkipUserMfa($reset: Boolean!) {
    skipUserMfa(reset: $reset)
  }
`;
